import { useNavigate, useRouter } from "@tanstack/react-router";
import { useMemo, useRef, useState } from "react";

import Icon from "@/components/Icon/Icon";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "@/components/ui/command";
import { filterAppRoutes, getStaffAppRoutes } from "@/lib/navigation/routeList";

import useCommandPaletteByKeyPress from "./useCommandPaletteByKeyPress";

// Command + kで、CommandPaletteを開き、ルートを検索、ジャンプできるようにするFeature.
// カイゼン：
// - ルート周りのことは、routeList.tsxを参照
// - ルートへのジャンプだけでなく、コマンドアクションを実行できるようにする

function CommandPalette() {
  // Use the custom hook for open/setOpen and global shortcut
  const { open, setOpen } = useCommandPaletteByKeyPress();
  const [search, setSearch] = useState("");
  const listRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const router = useRouter();
  const { flatRoutes } = router;

  // Dynamically get all /_staff routes using flatRoutes
  const routes = useMemo(() => getStaffAppRoutes(flatRoutes), [flatRoutes]);

  // Filter routes by search using the utility from routeList
  const filteredRoutes = useMemo(
    () => filterAppRoutes(routes, search),
    [routes, search],
  );

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput
        placeholder="ルートを検索… people, apps, settings…"
        value={search}
        onValueChange={setSearch}
      />
      <CommandList ref={listRef}>
        <CommandEmpty>該当するルートがありません。</CommandEmpty>
        <CommandGroup className="py-3 mx-2">
          <Icon
            iconName="InfoIcon"
            text="英語検索のみ対応。静的なルートしか表示されません。"
            colorVariant="warningOnNeutral"
            variant="small"
          />
        </CommandGroup>
        <CommandSeparator />
        <CommandGroup>
          {filteredRoutes.map((route) => {
            const LogoComponent = route.icon;
            return (
              <CommandItem
                key={route.path}
                value={route.label}
                onSelect={() => {
                  setOpen(false);
                  navigate({ to: route.path });
                }}
              >
                {LogoComponent && <LogoComponent className="w-4 h-4 mr-2" />}
                {route.label}
              </CommandItem>
            );
          })}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}

export default CommandPalette;
